import React from 'react';
import styled from 'styled-components';

import whiteIcon from '../../assets/logo/white_text.svg';

const Icon = styled.img`
  height: 40px;
`;

const Root = styled.div`
  display: flex;
  cursor: pointer;
  position: relative;
  align-items: center;
  align-self: stretch;
  flex-direction: row;
`;

const Divider = styled.div`
  width: 2px;
  display: flex;
  margin: 0 17px;
  height: 21.52px;
  background: #ffffff;
`;

const AppName = styled.span`
  display: flex;
  color: #ffffff;
  font-size: 24px;
  font-weight: 300;
  line-height: 28px;
  font-style: normal;
  text-align: center;
  align-items: center;
  font-family: 'Roboto' sans-serif;
`;

function Logo() {
  return (
    <Root>
      <Icon src={whiteIcon} alt="GAMEGOS" />
      <Divider />
      <AppName>Launcher</AppName>
    </Root>
  );
}

export default Logo;
